import React from "react";
import { Alert, Button, Modal, Spinner } from "react-bootstrap";

export function PlainText({ children, className = "" }) {
    return <div className={`plain-text ${className}`.trim()}>{children}</div>;
}

export function LoadState({ loading, error, empty, emptyText, children }) {
    if (loading) {
        return (
            <div className="admin-state" role="status">
                <Spinner animation="border" size="sm" className="me-2" />
                Inhalte werden geladen …
            </div>
        );
    }
    if (error) return <Alert variant="danger">{error}</Alert>;
    if (empty) return <div className="admin-state">{emptyText}</div>;
    return children;
}

export function ConfirmDeleteModal({ show, title, busy, onCancel, onConfirm }) {
    return (
        <Modal
            show={show}
            onHide={busy ? undefined : onCancel}
            centered
            className="admin-delete-modal"
            backdropClassName="admin-modal-backdrop"
        >
            <Modal.Header closeButton={!busy}>
                <Modal.Title>Eintrag löschen?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-0">
                    „{title}“ wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={onCancel} disabled={busy}>Abbrechen</Button>
                <Button variant="danger" onClick={onConfirm} disabled={busy}>
                    {busy && <Spinner animation="border" size="sm" className="me-2" />}
                    Endgültig löschen
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
